import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import makeComponentTrashable from 'trashable-react';
import { fetchTransactions } from 'Shared/util/web-api';
import Datepicker from 'Shared/components/datepicker';
import Page from 'Shared/components/page/page';
import filterStyles from 'Shared/components/list-filter.css';
import StatusMessage from 'Shared/components/status-message';
import { exportPage } from 'Shared/util/export-helper';
import ExportOptions from 'Shared/components/export-options';
import useTranslationContext from 'Contexts/translation-context';
import { useStatusMessage, useTranslation } from 'Shared/util/custom-hooks';
import TransactionFilter from './transaction-filter';
import TransactionTable from './transaction-table';


const TransactionsPage = ({
  registerPromise,
}) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusMessage, dispatchStatusMessage] = useStatusMessage();
  const { translationData } = useTranslationContext();
  const tg = useTranslation(x => x.global);
  const t = useTranslation(x => x.transactions);

  useEffect(() => {
    dispatchStatusMessage({ type: 'NONE' });
    registerPromise(fetchTransactions())
      .then((result) => {
        setTransactions(result);
        setLoading(false);
      });
  }, []);

  return (
    <Page title={t.recentPayments}>
      <TransactionFilter
        default={{
          fromDate: null,
          toDate: null,
        }}
        items={transactions}
        dismissExportAlert={() => dispatchStatusMessage({ type: 'NONE' })}
        render={(filterArgs) => (
          <>
            <div className={filterStyles.filterItemsContainer}>
              <div className={`${filterStyles.filterItem} ${filterStyles.filterDatesContainer}`}>
                <Datepicker
                  selected={filterArgs.filter.fromDate}
                  onChange={(date) => filterArgs.handleChange({ fromDate: date })}
                  label={t.paymentDate}
                  placeholder={tg.from}
                  language={translationData.languageCode}
                />
                <Datepicker
                  selected={filterArgs.filter.toDate}
                  onChange={(date) => filterArgs.handleChange({ toDate: date })}
                  placeholder={tg.to}
                  language={translationData.languageCode}
                />
              </div>
            </div>
            <ExportOptions exportPage={exportPage.TRANSACTIONS} filterArgs={filterArgs} dispatchStatusMessage={dispatchStatusMessage} />
            <StatusMessage status={statusMessage.type} text={statusMessage.message} clearStatus={() => dispatchStatusMessage({ type: 'NONE' })} />
            <TransactionTable
              rows={filterArgs.items}
              loading={loading}
            />
          </>
        )}
      />
    </Page>
  );
};

TransactionsPage.propTypes = {
  registerPromise: PropTypes.func.isRequired,
};

export default makeComponentTrashable(TransactionsPage);
